import ParticleSystems from './ParticleSystems';

class FireWork {
	constructor(p) {
		this.p = p;
		this.exploded = false;
		this.particles = [];
		this.fireWork = new ParticleSystems(
			p,
			p.random(p.width),
			p.random(p.height),
			true
		);
	}
	update() {
		if (!this.exploded) {
			//this.fireWork.applyForce(this.gravity);
			this.fireWork.update();

			// if (this.fireWork.vel.y >= 0) {
			// 	this.exploded = true;
			// 	//this.explode();
			// }
		}
		for (let i = this.particles.length - 1; i >= 0; i--) {
			this.particles[i].applyForce(this.gravity);
			this.particles[i].update();
			if (this.particles[i].isDone()) {
				this.particles.splice(i, 1);
			}
		}
	}
	show(mouseX, mouseY) {
		if (!this.exploded) {
			this.fireWork.show();
		}
		for (let i = 0; i < this.particles.length; i++) {
			this.particles[i].show();
		}

		if (
			this.p.abs(this.fireWork.pos.x - mouseX) < 200 &&
			this.p.abs(this.fireWork.pos.y - mouseY) < 200
		) {
			this.p.line(mouseX, mouseY, this.fireWork.pos.x, this.fireWork.pos.y);
		}
	}
	explode() {
		this.particles = [];
		for (let i = 0; i < this.p.random(10, 20); i++) {
			//console.log(i);
			let np = new ParticleSystems(
				this.p,
				this.fireWork.pos.x,
				this.fireWork.pos.y,
				false
			);
			this.particles.push(np);
		}
	}
	intersects(other) {
		//console.log(other);
		let d = this.p.dist(
			this.fireWork.pos.x,
			this.fireWork.pos.y,
			other.fireWork.pos.x,
			other.fireWork.pos.y
		);
		if (d < this.fireWork.r + other.fireWork.r) {
			return true;
		} else {
			return false;
		}
	}
}

export default FireWork;
